import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '@ui/settings/use-settings';
import { apiClient } from '../http/query-client';

declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

export function FacebookPixelTracker() {
  const { facebook } = useSettings();
  const location = useLocation();
  const pixelId = facebook?.pixel_id;

  // Dynamically initialize the Meta Pixel base code if configured
  useEffect(() => {
    if (!pixelId) return;

    if (!window.fbq) {
      /* eslint-disable */
      (function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
    }

    window.fbq('init', pixelId);
  }, [pixelId]);

  // Track PageView on route changes
  useEffect(() => {
    if (!pixelId || !window.fbq) return;

    const eventId = 'pv_' + Math.random().toString(36).substring(2, 15);
    
    // 1. Browser Event (Meta Pixel)
    window.fbq('track', 'PageView', {}, { eventID: eventId });

    // 2. Server Event (Conversions API Proxy)
    apiClient.post('facebook/event', {
      event_name: 'PageView',
      event_id: eventId,
      event_source_url: window.location.href,
    }).catch(() => {});
  }, [location.pathname, location.search, pixelId]);

  // Automatically track ViewContent on main landing/solution/pricing page loads
  useEffect(() => {
    if (!pixelId || !window.fbq) return;

    const path = location.pathname;
    const isLandingOrPricingOrSolution = 
      path === '/' || 
      path.startsWith('/pricing') ||
      path.includes('cloud-storage') ||
      path.includes('alternative');

    if (isLandingOrPricingOrSolution) {
      const eventId = 'vc_' + Math.random().toString(36).substring(2, 15);
      const contentName = path === '/' ? 'Home Page' : path.replace('/', '').replace(/-/g, ' ');

      // Browser Event
      window.fbq('track', 'ViewContent', {
        content_name: contentName,
      }, { eventID: eventId });

      // Server Event (CAPI Proxy)
      apiClient.post('facebook/event', {
        event_name: 'ViewContent',
        event_id: eventId,
        event_source_url: window.location.href,
        custom_data: {
          content_name: contentName,
        }
      }).catch(() => {});
    }
  }, [location.pathname, pixelId]);

  return null;
}
